import { isEqual } from "lodash";
import React, { useState } from "react";

import searchBackendContext from "../searchBackendContext";

export default function FallbackSearchBackendProvider({ children }) {
  const { Provider } = searchBackendContext;
  const [request, setRequest] = useState({});
  const isEmptyRequest = request == null;
  return (
    <Provider
      value={[
        {
          result: null,
          isEmptyRequest,
          isPending: !isEmptyRequest,
          error: null,
          isError: false,
        },
        (newRequest) => {
          if (!isEqual(newRequest, request)) setRequest(newRequest);
        },
      ]}
    >
      {children}
    </Provider>
  );
}
